import React, { createContext, useEffect, useState, useRef } from 'react';
import io from 'socket.io-client';
import { jwtDecode } from 'jwt-decode';
import { socket_base_url, socketiopath } from '../Components/Globallink';

const WebSocketContext = createContext(null);
const authToken = process.env.AUTH_TOKEN;

export const WebSocketProvider = ({ children }) => {
    const [socket, setSocket] = useState(null);
    const [userId, setUserId] = useState(null);
    const socketRef = useRef(null);

    useEffect(() => {
        const authyToken = localStorage.getItem(authToken);
        let decodedToken = null;

        if (authyToken) {
            try {
                decodedToken = jwtDecode(authyToken);
                setUserId(decodedToken.user_id);
            } catch (error) {
                console.error('Invalid token', error);
            }
        }

        socketRef.current = io(socket_base_url, {
            path: socketiopath,        // ✅ correct key
            auth: { token: authyToken },
            transports: ['websocket'],
            secure: true,              // ✅ true for HTTPS
            autoConnect: true,
            reconnection: true,
            reconnectionDelay: 1000,
            reconnectionAttempts: 5,
            timeout: 20000,
            upgrade: true,
            rememberUpgrade: true,
            withCredentials: true
        });

        socketRef.current.on('connect', () => {
            console.log('Socket Chat connected');
        });

        socketRef.current.on('disconnect', () => {
            console.log('Socket Chat disconnected');
        });

        socketRef.current.on('connect_error', (err) => {
            console.error('Socket connection error:', err.message);
        });

        setSocket(socketRef.current);

        return () => socketRef.current.close();
    }, []);

    return (
        <WebSocketContext.Provider value={{ socket, user_id: userId }}>
            {children}
        </WebSocketContext.Provider>
    );
};

export default WebSocketContext;
